var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"cbbfixed",staticStyle:{"bottom":"10px"},on:{"click":_vm.backToTop}},[_c('tk-link',{staticClass:"gotop cbbtn"},[_c('span',{staticClass:"up-icon"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }